import * as React from 'react'
import { ProjectGroupOverviewProps } from './types'
import useTableState from './use_table_state'
import TicketsTable from './tickets_table'
import StatusFilter from './status_filter'
import SavedFiltersDropdown from './saved_filters'
import ColumnsDropdown from './columns_dropdown'
import useColumnVisibility from './use_column_visibility'
import I18n from '../../../libs/i18n'

function ProjectGroupOverview({
  projectGroup,
  timeZone,
  adobePreviewFileOptions,
  savedFilters = [],
}: ProjectGroupOverviewProps) {
  const defaultSavedFilter = savedFilters.find((f) => f.is_default)
  const {
    visibleColumnKeys,
    visibleColumns,
    setVisibleColumnKeys,
  } = useColumnVisibility({
    columns: projectGroup.columns,
    projectGroupId: projectGroup.id,
  })

  const {
    activeFilter,
    searchTerm,
    setSearchTerm,
    sortKey,
    sortDirection,
    handleSort,
    toggleStatusFilter,
    filteredAndSortedRows,
    applyFilter,
    clearFilterUrlParams,
  } = useTableState({
    tickets: projectGroup.tickets,
    columns: projectGroup.columns,
    visibleColumnKeys,
    availableStatuses: projectGroup.available_statuses,
    initialFilter: defaultSavedFilter?.filter,
    timeZone,
  })

  return (
    <div className="project-group-overview">
      <div className="row table_header mb-3">
        <div className="col-auto">
          <div className="input-group" style={{ width: '250px' }}>
            <input
              id="search"
              type="text"
              className="form-control"
              placeholder={I18n.t('project_groups.overview.search_placeholder')}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>
        {projectGroup.available_statuses.length > 0 && (
          <div className="col">
            <StatusFilter
              statusOptions={projectGroup.available_statuses}
              selectedStatuses={Array.isArray(activeFilter.status) ? activeFilter.status as string[] : []}
              onToggleStatus={toggleStatusFilter}
            />
          </div>
        )}
        <div className="col-auto d-flex align-items-center">
          <SavedFiltersDropdown
            initialFilters={savedFilters}
            projectGroup={projectGroup}
            onApplyFilter={applyFilter}
            currentFilterData={activeFilter}
            clearFilterUrlParams={clearFilterUrlParams}
          />
          <ColumnsDropdown
            columns={projectGroup.columns}
            visibleColumnKeys={visibleColumnKeys}
            onVisibleColumnKeysChange={setVisibleColumnKeys}
          />
        </div>
      </div>
      <TicketsTable
        columns={visibleColumns}
        rows={filteredAndSortedRows}
        timeZone={timeZone}
        sortKey={sortKey}
        sortDirection={sortDirection}
        onSort={handleSort}
        adobePreviewFileOptions={adobePreviewFileOptions}
      />
    </div>
  )
}

export default ProjectGroupOverview
